import type { SxProps } from "@mui/material/styles";

export function mergeSxProps<
  // eslint-disable-next-line @typescript-eslint/ban-types -- Inherited from MUI types, but we need to keep it for compatibility.
  TTheme extends object = {},
>(...sxPropsArray: Array<SxProps<TTheme> | undefined>): SxProps<TTheme> {
  const mergedSx: SxProps & Array<any> = [];
  for (const sxProps of sxPropsArray) {
    if (!sxProps) continue;
    if (Array.isArray(sxProps)) {
      mergedSx.push(...sxProps);
    } else {
      mergedSx.push(sxProps);
    }
  }
  return mergedSx;
}
